import classNames from "classnames";
import React from "react";

import { testAttr } from "@/browser";
import { Animation, AnimationTarget } from "@/eworkitComponents";
import { Flex, Message, Text } from "@/eworkitComponents";
import { IWithMessagesProps, withMessages } from "@/eworkitComponents";
import { StickyMessage } from "@/views/components/Messenger/StickyMessage";

import "./_messenger.scss";

interface Props extends IWithMessagesProps {
  fixed?: boolean;
}

export class MessengerComponent extends React.PureComponent<Props> {
  componentWillUnmount() {
    const { context, deleteAllMessages } = this.props;
    deleteAllMessages(context);
  }

  render() {
    if (!this.props.messages.length) {
      return null;
    }

    const { context, deleteMessage, messages, stopMessageDying, startMessageToLiveAgain } = this.props;

    const classes = classNames("messenger", { "messenger--fixed": this.props.fixed });

    return (
      <Flex
        className={classes}
        direction="column"
        innerMargin
        {...testAttr({ testName: "messenger" }, { sufix: context })}>
        {messages.map(message => (
          <Animation key={message.id} animate onFinish={() => deleteMessage(message)}>
            {(_, finish) => (
              <AnimationTarget name="fade-grow">
                <Message
                  type={message.type}
                  onClose={finish}
                  onMouseEnter={() => stopMessageDying(message)}
                  onMouseLeave={() => startMessageToLiveAgain(message)}
                  testName={message.type}>
                  {this.props.fixed ? (
                    <StickyMessage {...message} />
                  ) : (
                    <Flex direction="column" innerMargin="sm">
                      {message.title && (
                        <Text align="center" whiteSpace="pre-wrap">
                          {message.title}
                        </Text>
                      )}
                      {message.text && (
                        <Text align="center" whiteSpace="pre-wrap">
                          {message.text}
                        </Text>
                      )}
                    </Flex>
                  )}
                </Message>
              </AnimationTarget>
            )}
          </Animation>
        ))}
      </Flex>
    );
  }
}

export const Messenger = withMessages(MessengerComponent);
